import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { AnimationOptions } from 'ngx-lottie';
import { Morador } from 'src/app/core/interfaces/usuario';
import { environment } from 'src/environments/environment';
import { controlVersion } from 'src/environments/version';

@Component({
  selector: 'app-atualizacoes-do-sistema',
  templateUrl: './atualizacoes-do-sistema.component.html',
  styleUrls: ['./atualizacoes-do-sistema.component.scss']
})
export class AtualizacoesDoSistemaComponent {

  redirectTo: string;
  title: string;
  subTitle: string;
  messages: string[];
  user: Morador;
  controlVersion = controlVersion;
  options: AnimationOptions = {
    path: '/assets/lottie/64741-isometric-app-animation.json',
  };

  confettiOptions: AnimationOptions = {
    path: '/assets/lottie/74680-confetti.json',
  };

  constructor(
    private swUpdate: SwUpdate,
    private ngbActiveModal: NgbActiveModal
  ) { }

  ngOnInit() {
    this.title = `Nova atualização`;
    this.messages = controlVersion ? controlVersion.messages : [`Oba a versão <strong>${environment.version}</strong> já está disponível, vamos aproveitar ?`];
  }

  atualizarVersaoDoSistema() {
    this.swUpdate.activateUpdate().then(() => location.reload());
  }

  close(action = 'close') {
    this.ngbActiveModal.close(action);
  }
}
